export default "__VITE_ASSET__CyQp3L3d__"